import React from 'react';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { Marquee } from '@components/main-components/marquee/Marquee';
import { webappUriPath } from '@utils/url';

export const SongTitle = ({
  songTitle,
  webappUri,
}: {
  songTitle: string;
  webappUri: string | null;
}) => {
  const content = (
    <span className="block w-fit whitespace-nowrap font-title text-title-xs font-medium text-base800">
      {songTitle}
    </span>
  );

  const scrollableContent = <Marquee>{content}</Marquee>;

  return (
    <div className="relative h-5 w-auto overflow-hidden">
      {webappUri ? (
        <AccessibleLink
          className="flex w-full max-w-[100%] items-center"
          pathnameUri={webappUriPath(webappUri)}
        >
          {scrollableContent}
        </AccessibleLink>
      ) : (
        scrollableContent
      )}
    </div>
  );
};
